import React from 'react';
import PropTypes from 'prop-types';
import CustomImage from './CustomImage';
import iconUp from '@src/assets/icons/icon-up.svg';
import iconDown from '@src/assets/icons/icon-down.svg';

const CustomExpandIcon = ({ isActive }) => {
  if (isActive) {
    return <CustomImage style={{ width: 20, height: 20 }} src={iconUp} />;
  }
  return <CustomImage style={{ width: 20, height: 20 }} src={iconDown} />;
};

// PropTypes tanımlaması
CustomExpandIcon.propTypes = {
  isActive: PropTypes.bool,
};

export default CustomExpandIcon;
